import type { Temporal } from 'temporal-polyfill';
import { useLocale } from '@/contexts/LocaleContext';
import { cn } from '@/lib/utils';

interface TimeFormatterProps {
  readonly value: Temporal.PlainTime | null | undefined;
  readonly className?: string;
  readonly options?: Intl.DateTimeFormatOptions;
  readonly nowrap?: boolean;
}

const defaultOptions: Intl.DateTimeFormatOptions = {
  hour: 'numeric',
  minute: 'numeric',
};

export function TimeFormatter({
  value,
  className,
  options,
  nowrap = true,
}: Readonly<TimeFormatterProps>) {
  const { locale } = useLocale();

  if (!value) return null;

  const resolvedOptions: Intl.DateTimeFormatOptions = {
    ...defaultOptions,
    ...options,
  };

  return (
    <time
      dateTime={value.toString()}
      className={cn(nowrap && 'whitespace-nowrap', className)}
    >
      {value.toLocaleString(locale, resolvedOptions)}
    </time>
  );
}
